import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { format, startOfMonth, set, isValid } from 'date-fns';


import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import PDFIcon from '@material-ui/icons/PictureAsPdf';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Typography } from '@material-ui/core';

import SelectTable from '../../components/DataTable/SelectTable';
import { fetchEmployees } from '../../store/actions/employee';
import { requestAbsenceReport } from '../../store/actions/report';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import Input from '../../components/Input/Input';

const styles = theme => ({
  container: {
    padding: `0 ${theme.spacing(3)}px`,
  },
});

class AbsenceReport extends React.Component {
  state = {
    startDate: '',
    endDate: '',
    selected: [],
    searchQuery: '',
  };

  componentWillMount() {
    this.setState({
      startDate: startOfMonth(new Date()),
      endDate: set(new Date(), { hours: 23, minutes: 59, seconds: 59 }),
    });
  }

  componentDidMount() {
    this.props.onFetchEmployees();
  }

  handleRequestReport = () => {
    const { startDate, endDate, selected } = this.state;

    const report = {
      start: format(startDate, 'yyyy/MM/dd HH:mm'),
      end: format(endDate, 'yyyy/MM/dd HH:mm'),
      employees: selected,
    };

    this.props.onRequestReport(report);
  };

  handleInputChange = name => (event) => {
    if (event && event.target) {
      this.setState({ [name]: event.target.value });
    } else {
      this.setState({ [name]: event });
    }
  };

  handleSelectAll = (event, checked, searchSelect) => {
    const searchIndex = searchSelect.map(employee => employee.id);

    if (checked) {
      const newSelected = this.state.selected.slice();

      /* eslint-disable no-underscore-dangle */
      if (searchIndex) {
        if (this.state.selected.indexOf(searchIndex[0]) === -1) {
          this.props.employees.map(employee =>
            (searchIndex.indexOf(employee.id) > -1 &&
              newSelected.indexOf(employee.id) === -1 &&
              employee._workingDay !== null
              ? newSelected.push(employee.id)
              : null));
        } else {
          this.props.employees.map(employee =>
            (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
              ? newSelected.splice(newSelected.indexOf(employee.id), 1)
              : null));
        }
      }
      /* eslint-enable */

      this.setState({ selected: newSelected });
    } else if (searchIndex.length === this.props.employees.length) {
      this.setState({ selected: [] });
    } else {
      const newSelected = this.state.selected.slice();
      this.props.employees.map(employee =>
        (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
          ? newSelected.splice(newSelected.indexOf(employee.id), 1)
          : null));

      this.setState({ selected: newSelected });
    }
  };

  handleSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, employees, loading } = this.props;
    const {
      startDate, endDate, selected, searchQuery,
    } = this.state;

    const columns = [
      { name: 'enrollment', label: 'Matrícula' },
      { name: 'name', label: 'Nome' },
      { name: '_office', label: 'Cargo' },
      { name: 'department', label: 'Departamento' },
      { name: '_workingDay', label: 'Escala' },
    ];

    const searchFields = ['enrollment', 'name', '_office', 'department', '_workingDay'];

    return (
      <React.Fragment>
        <ContentHeader
          title="Relatório Faltas por Período"
          subtitle="Selecione o período e os funcionários para gerar o relatório de faltas"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleRequestReport}
            disabled={loading || !(isValid(startDate) && isValid(endDate) && selected.length)}
          >
            <PDFIcon /> Gerar Relatório
          </Button>
        </ContentHeader>

        <Paper elevation={2}>
          <Grid container justify="space-between" className={classes.container}>
            <Grid item xs={12} md={5}>
              <TextField
                value={searchQuery}
                onChange={this.handleInputChange('searchQuery')}
                label=" "
                placeholder="Buscar"
                type="text"
                fullWidth
                margin="normal"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="disabled" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} container justify="space-around">
              <Input
                elementType="dateTimePicker"
                label="Início do período"
                margin="normal"
                value={startDate}
                onChange={this.handleInputChange('startDate')}
              />
              <Input
                elementType="dateTimePicker"
                minDate={startDate}
                label="Fim do período"
                margin="normal"
                value={endDate}
                onChange={this.handleInputChange('endDate')}
              />
            </Grid>
          </Grid>

          <SelectTable
            rows={employees}
            columns={columns}
            loading={loading}
            disableRow="_workingDay"
            searchFields={searchFields}
            onSelect={this.handleSelect}
            onSelectAll={this.handleSelectAll}
            onSearchSelect={this.handleSearchSelect}
            checkSelect={this.isSelected}
            numSelected={selected.length}
            searchQuery={searchQuery.toUpperCase()}
          />
        </Paper>

        <Typography color="textSecondary" style={{ marginTop: '10px' }}>
          *Não é possível gerar relatório de funcionários sem escala cadastrada
        </Typography>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  employees: state.employee.employees,
});

const mapDispatchToProps = dispatch => ({
  onFetchEmployees: () => dispatch(fetchEmployees()),
  onRequestReport: report => dispatch(requestAbsenceReport(report)),
});

AbsenceReport.propTypes = {
  classes: PropTypes.object.isRequired,
  onFetchEmployees: PropTypes.func.isRequired,
  onRequestReport: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

AbsenceReport.defaultProps = {
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(AbsenceReport));
